class LanguageProblem {
    constructor({
        example,
        feedback,
        title,
        url,
    }) {
        this._example = example;
        this._feedback = feedback;
        this._title = title;
        this._url = url;
    }
    get example() {
        return this._example;
    }
    get feedback() {
        return this._feedback;
    }
    get title() {
        return this._title;
    }
    get url() {
        return this._url;
    }
}

export default LanguageProblem;
